import { setLocalStorageItem } from '@/helpers/localStorage'

export type UserDetailsFormData = {
    badgeNumber?: string
    busHubCode: string
    dutyCode?: string
    noBadge: boolean
    noDuty: boolean
}

const USER_DETAILS_KEY = (accountId: string) => `CL/USER_DETAILS_${accountId}`

export const persistUserDetails = (accountId: string, formData: UserDetailsFormData) => {
    setLocalStorageItem<string>(USER_DETAILS_KEY(accountId), JSON.stringify(formData))
}

export const getPersistedUserDetails = (accountId: string): UserDetailsFormData | null => {
    const data = localStorage.getItem(USER_DETAILS_KEY(accountId))
    if (!data) return null

    try {
        return JSON.parse(data) as UserDetailsFormData
    } catch (error) {
        console.error('Error parsing user details from localStorage:', error)
        return null
    }
}
